import React, { useState, useEffect } from 'react';
import { FaCopy } from 'react-icons/fa';
// import TestWorkflowIcon from '../../assets/icons/test_workflow.svg';
import '../../styles/Lightbox.css';
import axios from 'axios';
import CustomAlert from '../common/CustomAlert/CustomAlert';
import { useAuth } from '../../contexts/AuthContext';

const GenerateSnippetButton = ({ workflowId, allPublished }) => {
  const [snippet, setSnippet] = useState('');
  const [copyStatus, setCopyStatus] = useState('');
  const [showLightbox, setShowLightbox] = useState(false);
  const [alertVisible, setAlertVisible] = useState(true);
  const { token } = useAuth();

  const handleClick = async () => {
    if (!allPublished) {
      alert('All templates must be published');
      return;
    }
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/workflows/generate-snippet/${workflowId}`,
        {
          headers: {
            Authorization: `${token}`,
          },
        }
      );
      if (response.status === 200) {
        // console.log(response.data.html);
        setSnippet(response.data.html);
        setShowLightbox(true);
      } else {
        console.error('Failed to generate snippet');
      }
    } catch (error) {
      console.error('Error generating snippet:', error);
    }
  };

  const handleCopy = () => {
    navigator.clipboard.writeText(snippet).then(
      () => {
        //alert('Snippet copied to clipboard!');
        {
          alertVisible && (
            <CustomAlert
              type="success"
              message="Operation was successful!"
              onClose={() => setAlertVisible(false)}
            />
          );
        }
        setCopyStatus('Copied');
      },
      (err) => {
        console.error('Could not copy snippet: ', err);
      }
    );
  };

  const handleClose = () => {
    setShowLightbox(false);
  };

  return (
    <div>
      <button
        style={{
          position: 'fixed',
          bottom: '10px',
          //left: 'auto',
          //right: '0',
          left: '15px',
          padding: '8px 16px',
          backgroundColor: 'var(--primary-color)',
          color: '#fff',
          border: 'none',
          borderRadius: '4px',
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          zIndex: 1000,
        }}
        onClick={handleClick}
      >
        Generate snippet
      </button>

      {showLightbox && (
        <div className="lightbox-overlay" onClick={handleClose}>
          <div
            className="lightbox-content"
            onClick={(e) => e.stopPropagation()}
          >
            <button className="lightbox-close" onClick={handleClose}>
              &times;
            </button>
            <h2>Generated Snippet</h2>
            <div className="lightbox-copy-outer">
              <button className="lightbox-copy" onClick={handleCopy}>
                <FaCopy style={{ marginRight: '5px' }} /> Copy
              </button>{' '}
              {copyStatus ? <span>{copyStatus}</span> : ''}
            </div>
            <div className="lightbox-snippet-container">
              <pre className="lightbox-snippet">{snippet}</pre>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default GenerateSnippetButton;

// Lightbox.css
